import { type FC } from 'react'

const IconWrapper: FC<{ icon: React.ReactNode; color?: string }> = ({ icon, color }) => {
  return (
    <div style={color ? { color } : {}} className="relative text-[14px] top-px">
      {icon}
    </div>
  )
}

export default IconWrapper
